
import HomeGenerator from './HomeGenerator';

export type GameConfig = {
    container: any
    objects: {
        src: string,
        iconSrc: string,
        key: string,
        isAvaiable: boolean,
        unavaialbeLabel: string
    }[],
    state: {
        stickers: StickerState[]
    }
    onChange: (state: GameConfig['state']) => void,
    userName: string,
    emblem: string
}

export type StickerState = {
    key: string,
    position: {
        x: number
        y: number,
    }
}

const BASE_WIDTH = 1366;
const BASE_HEIGHT = 810;

export default function createGame(config: GameConfig) {

    const app = new HomeGenerator(BASE_WIDTH, BASE_HEIGHT, 0xffffff, config)

    config.container.appendChild(app.view);
    app.gameResize();

    // ====================== //

    return {
        getSceenBlob: () => app.getSceenBlob(),
        uninstall: () => {
            app.destroy();
        },
        reset: () => {
            app.reset();
        }
    };
}





